import React, { useCallback, useState } from 'react';
import { useCookies } from 'react-cookie';
import { Modal } from '../../../../components';
import './rating-dialog.scss';
const BASE_SRC = '../../../../assets/icons/legacy';
const EXT_COOKIE_KEY = '$ext';
var Thumbs;
(function (Thumbs) {
    Thumbs["up"] = "up";
    Thumbs["down"] = "down";
})(Thumbs || (Thumbs = {}));
function addCssPrefix(name) {
    return `RatingDialog__${name}`;
}
export const RatingDialog = ({ extension, onSubmit, onClose, }) => {
    const [isShownMsg, setIsShownMsg] = useState(false);
    const [rating, setRating] = useState(undefined);
    const [cookies, setCookie] = useCookies([EXT_COOKIE_KEY]);
    const [activeThumb, setActiveThumb] = useState();
    const isFilledUp = rating === 0 || activeThumb === Thumbs.up;
    const isFilledDown = rating > 0 || activeThumb === Thumbs.down;
    const thumbUpSrc = `${BASE_SRC}/thumb-${isFilledDown ? 'filled' : 'outline'}-up.svg`;
    const thumbDownSrc = `${BASE_SRC}/thumb-${isFilledUp ? 'filled' : 'outline'}-down.svg`;
    const handleChangeRate = useCallback((value) => {
        return () => {
            const values = cookies[EXT_COOKIE_KEY];
            const newValue = {
                ...values ? values : {},
                [extension.id]: value,
            };
            setCookie(EXT_COOKIE_KEY, JSON.stringify(newValue));
            setRating(value);
            setIsShownMsg(true);
            onSubmit(value);
        };
    }, [cookies, extension]);
    const handleAfterOpen = useCallback(() => {
        const values = cookies[EXT_COOKIE_KEY];
        if (extension && values && typeof values[extension.id] === 'number') {
            setRating(values[extension.id]);
        }
        else {
            setRating(undefined);
        }
    }, [cookies, extension]);
    const handleCloseMsg = () => {
        onClose();
        setIsShownMsg(false);
    };
    const handleMouseEnter = useCallback((type) => {
        return () => {
            setActiveThumb(type);
        };
    }, []);
    const handleMouseOut = useCallback(() => {
        setActiveThumb(undefined);
    }, []);
    return (<Modal isOpen={!!extension} onAfterOpen={handleAfterOpen} onClose={handleCloseMsg} testId="ratingDialog" shouldCloseOnOverlayClick={false} styles={{
            padding: "48px 64px 50px",
            maxWidth: "474px"
        }}>
      {extension && (<div className={addCssPrefix('wrapper')}>
          <div className={addCssPrefix('logo')}>
            <img src={extension.icon} alt={extension.title}/>
          </div>
          <div className={addCssPrefix('title')}>
            {extension.optionalDescription}
          </div>
          <div className={addCssPrefix('sub-title')}>How likely you would be to install this extension?</div>
          <div className={addCssPrefix('rating-wrapper')}>
            <div className={addCssPrefix('rating-item')} onClick={handleChangeRate(0)} onMouseEnter={handleMouseEnter(Thumbs.up)} onMouseLeave={handleMouseOut}>
              <img src={thumbDownSrc} alt={Thumbs.down}/>
              <div className={addCssPrefix('text')}>Not Likely</div>
            </div>
            <div className={addCssPrefix('rating-item')} onClick={handleChangeRate(1)} onMouseEnter={handleMouseEnter(Thumbs.down)} onMouseLeave={handleMouseOut}>
              <img src={thumbUpSrc} alt={Thumbs.up}/>
              <div className={addCssPrefix('text')}>Very Likely</div>
            </div>
          </div>
          {isShownMsg && <div className={addCssPrefix('gratitude')}>Thank you for sharing!</div>}
        </div>)}
    </Modal>);
};
